/* @flow */
import React from 'react';
import {
  View, ScrollView, StyleSheet,
} from 'react-native';
import { useSelector } from 'react-redux';
import {
  Text, Surface,
} from 'react-native-paper';
import Icon from 'react-native-vector-icons/FontAwesome';
import dayjs from 'dayjs';

import { useColors } from '../contexts/theme';
import { startMorningsAtSelector, startEveningsAtSelector, laterTodayDelayMinutesSelector } from '../modules/settings/selectors';
import { useUpdateSetting } from '../modules/settings/actions';
import l from '../utils/localization';
import TimePicker from '../components/TimePicker';
import Select from '../components/Select';
import PremiumInfo from '../components/PremiumInfo';


const styles = StyleSheet.create({
  scrollView: { },
  container: { marginVertical: 20, flex: 1 },
  row: {
    flexDirection: 'row', alignItems: 'center', borderBottomWidth: 1, flex: 1, paddingVertical: 20, justifyContent: 'space-between',
  },
  actionPart: { marginRight: 20 },
  innerRow: { flexDirection: 'row', paddingLeft: 20, alignItems: 'center' },
  icon: { paddingRight: 15 },
});

const laterOptions = [{ label: '1h', value: 60 }, { label: '2h', value: 120 }, { label: '3h', value: 180 }, { label: '4h', value: 240 }];

const TimingSettings = () => {
  const colors = useColors(),
        startMorningsAtCurrent = useSelector(startMorningsAtSelector),
        startEveningsAtCurrent = useSelector(startEveningsAtSelector),
        laterTodayDelayMinutesCurrent = useSelector(laterTodayDelayMinutesSelector),
        updateSetting = useUpdateSetting();


  /*
              <Surface style={[styles.container, { backgroundColor: colors.surface }]}>
                <View style={[styles.row, { borderColor: colors.separator, paddingVertical: 20 }]}>
                  <Icon
                    color={colors.text}
                    style={{
                      flex: 1, textAlign: 'center',
                    }}
                    name='briefcase'
                  />
                  <Text style={{ flex: 2, textAlign: 'center' }}>{l.startWeeksOn}</Text>
                  <Text style={{ flex: 1, textAlign: 'center' }}>Monday</Text>
                </View>

              </Surface>
        */

  return (
    <ScrollView style={[styles.scrollView, { backgroundColor: colors.background }]}>
      <View style={{
        alignSelf: 'center', flex: 1, width: '100%', maxWidth: 500,
      }}
      >
        <PremiumInfo />
        <Surface style={[styles.container, { backgroundColor: colors.surface }]}>
          <View style={[styles.row, { borderColor: colors.separator, paddingVertical: 20 }]}>
            <View style={styles.innerRow}>
              <Icon
                color={colors.text}
                style={styles.icon}
                name='sun-o'
              />
              <Text>{l.startMorningsAt}</Text>
            </View>
            <View style={styles.actionPart}>
              <TimePicker
                currentDate={dayjs().startOf('day').add(startMorningsAtCurrent, 'minutes')}
                maxDate={dayjs().startOf('day').add(840, 'minutes')}
                minDate={dayjs().startOf('day')}
                onUpdateDate={(date) => {
                  const newValue = dayjs(date),
                        startOfDay = newValue.startOf('day'),
                        startMorningsAtMinuteOffset = newValue.diff(startOfDay, 'minutes');

                  if (startMorningsAtMinuteOffset.valueOf() !== startMorningsAtCurrent.valueOf()) {
                    updateSetting({ startMorningsAtMinuteOffset });
                  }
                }}
              />
            </View>
          </View>
          <View style={[styles.row, {
            borderColor: colors.separator, borderBottomWidth: 0,
          }]}
          >
            <View style={styles.innerRow}>
              <Icon
                color={colors.text}
                style={styles.icon}
                name='moon-o'
              />
              <Text>{l.startEveningsAt}</Text>
            </View>
            <View style={styles.actionPart}>
              <TimePicker
                currentDate={dayjs().startOf('day').add(startEveningsAtCurrent, 'minutes')}
                maxDate={dayjs().startOf('day').add(1380, 'minutes')}
                minDate={dayjs().startOf('day').add(900, 'minutes')}
                onUpdateDate={(day) => {
                  const date = dayjs(day),
                        startOfDay = date.startOf('day'),
                        startEveningsAtMinuteOffset = date.diff(startOfDay, 'minutes');

                  if (startEveningsAtCurrent.valueOf() !== startEveningsAtMinuteOffset.valueOf()) {
                    updateSetting({ startEveningsAtMinuteOffset });
                  }
                }}
              />
            </View>
          </View>
        </Surface>

        <Surface style={[styles.container, { backgroundColor: colors.surface }]}>
          <View style={[styles.row, { borderColor: colors.separator, paddingVertical: 20, borderBottomWidth: 0 }]}>
            <View style={styles.innerRow}>
              <Icon
                color={colors.text}
                style={styles.icon}
                name='coffee'
              />
              <Text>{l.laterToday}</Text>
            </View>
            <View style={styles.actionPart}>
              <Select
                options={laterOptions}
                onSelect={(laterTodayDelayMinutes) => {
                  if (laterTodayDelayMinutes.valueOf() !== laterTodayDelayMinutesCurrent.valueOf()) {
                    updateSetting({ laterTodayDelayMinutes });
                  }
                }}
                selectedOption={laterOptions.find(({ value }) => value === laterTodayDelayMinutesCurrent)}
              />
            </View>
          </View>

        </Surface>
      </View>
    </ScrollView>
  );
};

TimingSettings.navigationOptions = {
  title: l.timingSettings,
};

export default TimingSettings;
